<div class="row" *ngIf="isLoaded">
    <div class="col-md-12 p-0">
        <app-conference
            [scheduleId]="scheduleId"
            [candidateId]="candidateId"
            [jobId]="jobId"
            [jobMatchId]="jobMatchId"
            [workflowStep]="workflowStep"
            [type]="type"
            [mode]="mode">
        </app-conference>
    </div>
</div>

<div class="row d-flex justify-content-center mt-2" *ngIf="!isLoaded">
    <div class="col-xs-10 conference-container" style="height:95vh; padding-top:100px">
        <app-skeleton-loader variant="block" [rows]="6"></app-skeleton-loader>
    </div>
</div>
